import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLeftSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronLeftSmall"><Path fillRule="evenodd" clipRule="evenodd" d="M13.9998 6.58594L8.58564 12.0002L13.9998 17.4144L15.4141 16.0002L11.4141 12.0002L15.4141 8.00015L13.9998 6.58594Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLeftSmall;
